export function access_token(state) {
	return state.access_token
}

export function admin_left_menu(state) {
	return state.admin_left_menu
}

export function accept_terms_and_conditions(state) {
	return state.accept_terms_and_conditions
}

export function device_token(state) {
	return state.device_token
}

export function email(state) {
	return state.email
}

export function email_unsubscribe(state) {
	return state.email_unsubscribe
}

export function full_name(state) {
	return state.full_name
}

export function created_at(state) {
	return state.created_at
}

export function has_mandatory_surveys(state) {
	return state.has_mandatory_surveys
}

export function id(state) {
	return state.id
}

export function id_user_campaign_selected(state) {
	return state.id_user_campaign_selected
}

export function id_user_client_country_selected(state) {
	return state.id_user_client_country_selected
}

export function id_user_client_profile(state) {
	return state.id_user_client_profile
}

export function id_user_client_selected(state) {
	return state.id_user_client_selected
}

export function id_user_language_selected(state) {
	return state.id_user_language_selected
}

export function user_language_selected(state) {
	return state.user_language_selected
}

export function is_superuser(state) {
	return state.is_superuser
}

export function left_menu(state) {
	return state.left_menu
}

export function refresh_token(state) {
	return state.refresh_token
}

export function reload_content(state) {
	return state.reload_content
}

export function right_menu(state) {
	return state.right_menu
}

export function user_client_module_items(state) {
	return state.user_client_module_items
}

export function user_clients(state) {
	return state.user_clients
}

export function user_countries(state) {
	return state.user_countries
}

export function user_firebase_document(state) {
	return state.user_firebase_document
}

export function user_firebase_document_ranking_areas(state) {
	return state.user_firebase_document_ranking_areas
}

export function document(state) {
	return state.document
}

export function birthday(state) {
	return state.birthday
}

export function phone_mobile_number(state) {
	return state.phone_mobile_number
}

export function user_firebase_token(state) {
	return state.user_firebase_token
}

export function user_image(state) {
	return state.user_image
}

export function user_module_items(state) {
	let obj = state.user_client_module_items.find((obj) => {
		return obj.id == state.id_user_client_selected
	})
	if (obj) return obj.module_items
	else return []
}

export function user_reward_campaign(state) {
	return state.user_reward_campaign
}

export function webservice_token(state) {
	return state.webservice_token
}

export function user_branches(state) {
	return state.user_branches
}

export function user_campaigns(state) {
	return state.user_campaigns
}

export function status(state) {
	return state.status
}

export function user_change_password(state) {
	return state.user_change_password
}

export function redirect_url(state) {
	return state.redirect_url
}

export function accept_cookies_policy(state) {
	return state.accept_cookies_policy
}

export function date_request_set_user_data(state) {
	return state.date_request_set_user_data
}
export function has_mandatory_drills(state) {
	return state.has_mandatory_drills
}

export function has_close_banner_drills(state) {
	return state.has_close_banner_drills
}
export function must_change_password(state) {
	return state.must_change_password
}

export function set_locale_processed(state) {
	return state.set_locale_processed
}

export function verificacion_phone_button(state) {
	return state.verificacion_phone_button
}

export function insider_init_dispatched(state) {
	return state.insider_init_dispatched
}
